import React from 'react'
import Images from '../../assets/images';
import './Clients.css';
import { Grid } from '@mui/material';

const Clients = () => {

  return (
    <Grid container className='clients desktop' justifyContent={'space-between'} >
      {
        Object.values(Images.clients).map((item, index) => (
          <img className='image' src={item} alt={item.label} />
        ))
      }
    </Grid>

  )
}

export default Clients 